import { render } from "./JiffyPromotionBlanks.vue?vue&type=template&id=46cc85ca&scoped=true"
import script from "./JiffyPromotionBlanks.vue?vue&type=script&lang=js"
export * from "./JiffyPromotionBlanks.vue?vue&type=script&lang=js"

import "./JiffyPromotionBlanks.vue?vue&type=style&index=0&id=46cc85ca&lang=scss&scoped=true"

import exportComponent from "../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.8.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46cc85ca"]])

export default __exports__